import { useGetLogo } from "@/services/api/hooks/images";
import { usePropertyBagForRole } from "@/services/api/hooks/settings";
import { useRole } from "@/services/authentication/hooks/user";

export const useCanShowBrandedLogo = () => {
  const role = useRole();
  const [logoUrl] = useGetLogo(role.partnerId);
  const canReplaceBranding = useCanReplaceDaaSBranding();

  return Boolean(canReplaceBranding && logoUrl);
};

const useCanReplaceDaaSBranding = () => {
  const [propertyBag] = usePropertyBagForRole();

  return Boolean(propertyBag?.allowCustomLogo);
};